module.exports = __webpack_public_path__ + "img/cisco-3.0aeddc76.webp";